import React, { useEffect } from "react";
import Sidebar from "src/components/common/Sidebar";
import PrizeDetailsPage from "src/components/events/prize/prizeDetails";
import { RODEO_PAGE_NAME, APPLICATION_NAME } from "src/_config";

export default function PrizeDetailsContainer() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Prize`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      <section className="main-container">
        <Sidebar page={RODEO_PAGE_NAME.EVENT_GAME_LIST} />
        {/* <div className="event-sec">
                <div className="container"> */}
        <PrizeDetailsPage />
        {/* </div>
            </div> */}
      </section>
    </React.Fragment>
  );
}
